import { render, staticRenderFns } from "./approvalFooter.vue?vue&type=template&id=2192afa0"
import script from "./approvalFooter.vue?vue&type=script&lang=js"
export * from "./approvalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports